import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039 } from './P00039';
import { P0003600FunctionFinish } from './P0003600/Installation/P0003600InstallationFinish';
import { P00032 } from './P00032';
import { P00030 } from './P00030';
import { P00039DataRxTxIndex } from './P00039Sync';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P0003600FiltrationMiseEnOeuvreInit } from './P0003600/Filtration/miseenoeuvre/P0003600FiltrationMiseEnOeuvreInit';
import { P0003600FiltrationStatutComponent } from './P0003600/Filtration/cps/p0003600-filtration-statut/p0003600-filtration-statut.component';
import { P0003600FiltrationParametersComponent } from './P0003600/Filtration/cps/p0003600-filtration-parameters/p0003600-filtration-parameters.component';
import { P0003600FiltrationControleComponent } from './P0003600/Filtration/cps/p0003600-filtration-controle/p0003600-filtration-controle.component';
import { P0003600FiltrationMiseEnOeuvreFiltrationEauBassinComponent } from './P0003600/Filtration/miseenoeuvre/p0003600-filtration-mise-en-oeuvre-filtration-eau-bassin/p0003600-filtration-mise-en-oeuvre-filtration-eau-bassin.component';
import { P0003600FiltrationMiseEnOeuvreFonctionnalitesPreventionComponent } from './P0003600/Filtration/miseenoeuvre/p0003600-filtration-mise-en-oeuvre-fonctionnalites-prevention/p0003600-filtration-mise-en-oeuvre-fonctionnalites-prevention.component';
import { P0003600FiltrationMiseEnOeuvreFonctionnalitesPreventionGelComponent } from './P0003600/Filtration/miseenoeuvre/p0003600-filtration-mise-en-oeuvre-fonctionnalites-prevention-gel/p0003600-filtration-mise-en-oeuvre-fonctionnalites-prevention-gel.component';
import { P0003600CardFiltrationStatutComponent } from './P0003600/Filtration/cards/p0003600-card-filtration-statut/p0003600-card-filtration-statut.component';
import { P0003600CardFiltrationControleComponent } from './P0003600/Filtration/cards/p0003600-card-filtration-controle/p0003600-card-filtration-controle.component';
import { P0003600FunctionReset } from './P0003600/Installation/P0003600InstallationReset';
import { P0003600InstallationPompeComponent } from './P0003600/Installation/p0003600-installation-pompe/p0003600-installation-pompe.component';
import { P00045Alarm } from './P00045/Alarm/P00045Alarm';
import { P0003600Alarm } from './P0003600/Alarm/P0003600Alarm';

export class P0003600Data {
  fsCModeFonctionnement: number = 0;

  fsCProgrammeFiltrationAuto: number = 0;

  fsCResetManuelProtectionMagnetique: number = 0;

  fsCResetManuelProtectionThermique: number = 0;

  fsCConfirmationOTA: number = 0;

  fsCResetUsine: number = 0;

  fsPTypeHorlogePPH: number = 0;

  fsPTypeHorlogePPE: number = 0;

  fsPActivationFonctionFiltration2424: number = 0;

  fsPHeureDepart: number = 0;

  fsPDureeAjustementLoiDEau: number = 0;

  fsPHorlogePicotJourPPH: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  fsPHorlogePicotSemainePPH: string = '000000000000';

  fsPHorlogePicotJourPPE: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  fsPHorlogePicotSemainePPE: string = '000000000000';

  fsPSeuilTemperatureFonctionFiltration2424: number = 25;

  fsPTypeFonctionHorsGel: number = 0;

  fsPSeuilTemperatureFonctionHorsGel: number = 0;

  fsIConfigurationProduit: number = 0;

  fsIActivationProtectionThermique: number = 0;

  fsIActivationProtectionMagnetique: number = 0;

  fsICourantNominalPompe: number = 10;

  fsICapteurTemperatureFiltration2424: number = 0;

  fsICapteurTemperatureReferenceLoiDEau: number = 0;

  fsICapteurTemperatureReferenceHorsGel: number = 0;

  fsIDureeDetectionMaintenue: number = 0;

  fsISeuilCourantDetection: number = 4;

  fsSCommandePompe: number = 0;

  fsSEtatPompe: number = 0;

  fsSEtatProtectionMagnetique: number = 0;

  fsSEtatProtectionThermique: number = 0;

  fsSEtatBouton: number = 0;

  fsSDetectionFonctionnementPompe: number = 0;

  fsSAlarme: number = 0;

  fsSCourantConsomePompe: number = 0;

  fsSNombreCommutationRelais: number = 0;

  fsSTensionSecteur: number = 0;

  fsSPuissanceApparente: number = 0;

  fsSPuissanceActive: number = 0;

  fsSCompteurPuissanceApparenteTotal: number = 0;

  fsSCompteurPuissanceActiveTotale: number = 0;

  fsSCompteurAmpereHeure: number = 0;

  fsSTempsSousTension: number = 0;

  fsSCompteurBouton: number = 0;

  fsSTemperatureReferenceDisponibleLoiDEau: number = 0;

  fsSPompeFiltrationPiloteLoiDEau: number = 0;

  fsSPompeFiltrationPilotePPH: number = 0;

  fsSPompeFiltrationPilotePPE: number = 0;

  fsSTemperatureReferenceDisponible2424: number = 0;

  fsSPompeFiltrationPilote2424: number = 0;

  fsSPompeFiltrationPilote72H: number = 0;

  fsSPompeFiltrationPiloteUsine1: number = 0;

  fsSPompeFiltrationPiloteUsine2: number = 0;

  fsSPompeFiltrationPiloteUsine3: number = 0;

  fsSTemperatureReferenceDisponibleHorsGel: number = 0;

  fsSPompeFiltrationPiloteHorsGel: number = 0;

  fsSEntreeAsserviePrioriteElectrolyseElectrolyseurStandard: number = 0;

  fsSEntreeAsservieAutoMaintienFiltrationElectrolyseurStandard: number = 0;

  fsSEntreeAsservieAutoMaintienFiltrationInjectionCL: number = 0;

  fsSEntreeAsserviePrioriteElectrolyseElectrolyseurCellule: number = 0;

  fsSEntreeAsservieAutoMaintienFiltrationElectrolyseurCellule: number = 0;

  fsSEntreeAsservieAutoMaintienFiltrationInjectionPH: number = 0;

  fsSEntreeAsservieAutoMaintienFiltrationInjectionPAC: number = 0;

  fsSEntreeAsservieRedemarrageEclairageStandard: number = 0;

  fsSEntreeAsservieRedemarrageEclairageTunable: number = 0;

  fsSEntreeAsserviePrioriteRobot: number = 0;

  fsSEntreeAsservieAutoMaintienRobot: number = 0;

  fsSPompeFiltrationFonctionEntreeAsservi: number = 0;

  fsSEntreeAsserviFonctionPrioritePacWp: number = 0;

  fsSEntreeAsserviFonctionAutoMaintienPacWp: number = 0;

  fsSEntreeAsserviFonctionPrioritePac: number = 0;

  fsSEntreeAsserviFonctionPrioritePacPoly: number = 0;

  fsSEntreeAsserviFonctionAutoMaintienPacPoly: number = 0;

  fsSEntreeAsserviArretFiltrationVolet24: number = 0;

  fsSEntreeAsserviArretFiltrationVolet230: number = 0;

  fsSAsservissement: number = 0;

  fsSMesureTemperatureLoiDEau: number = 0;

  fsSDureeFiltrationMinuteLoiDEau: number = 0;

  fsSHeureArretMinuteLoiDEau: number = 0;

  fsSCompteARebours72H: number = 0;

  fsSDureeFiltrationMinuteUsine1: number = 0;

  fsSHeureArretMinuteUsine1: number = 0;

  fsSDureeFiltrationMinuteUsine2: number = 0;

  fsSHeureArretMinuteUsine2: number = 0;

  fsSDureeFiltrationMinuteUsine3: number = 0;

  fsSHeureArretMinuteUsine3: number = 0;

  fsSMesureTemperature2424: number = 0;

  fsSMesureTemperatureHorsGel: number = 0;

  fsSEtatFonctionHorsGel: number = 0;

  fsSCompteAReboursEtatDiscontinu: number = 0;

  fsSCompteurResetManuelProtectionMagnetique: number = 0;

  fsSCompteurResetManuelProtectionThermique: number = 0;

  fsSCompteurResetUsine: number = 0;
}

export class P0003600 extends IProduct {
  override deviceTableIndex: number = 1;

  override modelIdentifier?: string = 'P00036-00';

  override dataIdentifier?: string = 'P0003600';

  override manufacturerName?: string = 'ACWA';

  data: P0003600Data = new P0003600Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0003600/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0003600/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0003600/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0003600;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0003600?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0003600.tuto.installation.help.title',
      helpSlides: [
        'P0003600.tuto.installation.help.1',
        'P0003600.tuto.installation.help.2',
        'P0003600.tuto.installation.help.3',
        'P0003600.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003600/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003600/installation-1_dark.png',
          },
          text: 'P0003600.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003600/installation-2.png',
            dark: '/assets/ecosystem/images/products/P0003600/installation-2_dark.png',
          },
          text: 'P0003600.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003600/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003600/installation-1_dark.png',
          },
          text: 'P0003600.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P0003600/update-2.png',
            dark: '/assets/ecosystem/images/products/P0003600/update-2_dark.png',
          },
          text: 'P0003600.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P0003600InstallationPompeComponent,
            condition: () => {
              return true;
            },
          },
        ],
        finish: P0003600FunctionFinish,
        reset: P0003600FunctionReset,
      },

      statusCards: [
        { component: P0003600CardFiltrationStatutComponent, weight: 12 },
      ],

      controlCards: [
        { component: P0003600CardFiltrationControleComponent, weight: 12 },
      ],

      alarms: {
        weight: 11,
        component: P0003600Alarm,
      },

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.FILTRATION];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.FILTRATION_STANDARD ||
      functionnality == EventProductFunctionnalityEnum.FILTRATION
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component:
                P0003600FiltrationMiseEnOeuvreFiltrationEauBassinComponent,
              condition: () => {
                return true;
              },
            },
            {
              component:
                P0003600FiltrationMiseEnOeuvreFonctionnalitesPreventionComponent,
              condition: (pool: Pool) => {
                return new P00039().hasProduct(pool, new P00032()) > 0;
              },
            },
            {
              component:
                P0003600FiltrationMiseEnOeuvreFonctionnalitesPreventionGelComponent,
              condition: (pool: Pool) => {
                return (
                  new P00039().hasProduct(pool, new P00032()) > 0 ||
                  new P00039().hasProduct(pool, new P00030()) > 0
                );
              },
            },
          ],
          init: P0003600FiltrationMiseEnOeuvreInit,
        },

        controle: {
          enabledUser: true,
          enabledSupport: true,
          component: P0003600FiltrationControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P0003600FiltrationParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P0003600FiltrationStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,

            graphiques: [
              {
                title: 'P0003600.parameters.historique.suivi.commandePompe',
                mode: HistoryGraphModeEnum.EVENT,
                codeEvent: 33,
                yMode: HistoryGraphYModeEnum.HOUR,
                property: 'fsSCommandePompe',
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
                showDirectly: true,
              },
              {
                title: 'P0003600.parameters.historique.suivi.puissance',
                mode: HistoryGraphModeEnum.DATA,
                property: 'fsSCompteurPuissanceActiveTotale',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.WATT,
                yModeOptions: { min: 0, max: 1000 },
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
            ],
          },
        },
      };
    }

    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.FiltrationStandard_Controle,
      propertyName: 'fsCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 19;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).fsIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
